import {Component} from '@angular/core';

@Component({
  templateUrl: './agreements-sign-success-page.component.html',
})
export class AgreementsSignSuccessPageComponent {
  constructor() {
  }
}
